/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconGrenade: {
  name: 'grenade';
  data: string;
} = {
  name: 'grenade',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m455.568 151.762 19.215 5.149 23.022-85.918L295.368 16.75l-8.527 31.823c-116 .817-204.884 152.448-238.482 277.839l13.598 68.674c57.134-170.36 137.625-271.444 213.113-291.687l28.475 7.63c-73.236 22.211-139.962 96.072-166.698 195.853-26.921 100.472-5.594 198.465 47.524 254.124l46.017 12.33a116.5 116.5 0 0 0 2.807 6.989l1.559-5.819 42.618 11.42-1.559 5.819a115.79 115.79 0 0 0 5.926-4.649l52.048 13.946c73.832-21.643 141.298-95.844 168.219-196.316 26.737-99.782 5.88-197.111-46.438-252.964z"/></svg>`,
};
